import { Stack } from "~/common/mui";
import type { PageTemplateProps } from "./pageTemplateTypes";

const SECTION_SPACING = { xs: 2, tablet: 3 } as const;

/**
 * Slot-driven React template for the homepage ContentPage, whose backend
 * {@code metadata.templateUid} is {@code "LandingPage2Template"}.
 *
 * The homepage has no React island — {@code body} is null on this route — so ALL
 * rendered content comes from the page-scoped CMS slots. They are rendered in
 * OOTB top-to-bottom order as a clean vertical stack. This is the deliberate
 * 1:1 slot-order first cut agreed for task 0161; reproducing the legacy
 * {@code LandingLayout2Page} responsive grid is out of scope.
 *
 * Page-scoped slots: {@code Section1}, {@code Section2A}, {@code Section2B},
 * {@code Section3}, {@code Section4}, {@code Section5}. {@code Section2C} is
 * declared on the type but NOT wired to the homepage via {@code ContentSlotForPage}
 * and is intentionally omitted.
 */
export function HomePagePageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <Stack spacing={SECTION_SPACING}>
      {slots.renderSlot("Section1")}
      {slots.renderSlot("Section2A")}
      {slots.renderSlot("Section2B")}
      {slots.renderSlot("Section3")}
      {slots.renderSlot("Section4")}
      {slots.renderSlot("Section5")}
      {body}
    </Stack>
  );
}
